import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild
} from "@angular/core";
import { MatMenuTrigger } from "@angular/material/menu";
import {
  trigger,
  state,
  style,
  animate,
  transition,
} from "@angular/animations";
import { ADPResourceService as ResourceService } from 'digital-core';


@Component({
  selector: "adp-portal-profile-menu",
  templateUrl: "./adp-portal-profile-menu.component.html",
  styleUrls: ["./adp-portal-profile-menu.component.scss"],
})
export class adpPortalProfileMenuComponent implements OnInit {
  @Input() profileMenu;
  @Input() profileImg;
  @Input() loginUserName;
  @Output() action = new EventEmitter<string>();
  @ViewChild(MatMenuTrigger, { static: true }) trigger: MatMenuTrigger;

  constructor(public resourceService: ResourceService,) {}

  ngOnInit() {
   this.loginUserName = this.resourceService
     .getViewLabel("Global_Profile_Menu_Header")
     .replace("{UserName}", this.loginUserName);
  }

  performAction(actionName) {
    this.action.emit(actionName);
  }
}
